import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Css
import classes from "./testEventCard.module.css";

// Img
import calendar from "../../../assets/png/calendar.png";
import icCalendarRound from "../../../assets/svg/ic-calendar-grey-round.svg";
import icClockRound from "../../../assets/svg/ic-clock-grey-round.svg";
import icTeamRound from "../../../assets/svg/ic-team-grey-round.svg";
import icLocationRound from "../../../assets/svg/ic-location-grey-round.svg";

// Jds
import { BadgeV2, Button, Container, Icon, Tooltip } from "@jds/core";

// Local
import { addParamsURL, baseToImg } from "../../../util/helper";
import decryptUrl from "../../../util/img-decryption";
import RescheduleEventForm from "../Form/RescheduleEventForm";
import JdsModal from "../JdsModal";
import SuccessModal from "../SuccessModal/SuccessModal";
import { useDispatch, useSelector } from "react-redux";
import { eventListTrigger } from "../../../store/state-slices/apiTrigger";
import CardOverlay from "./CardOverlay";
import { Stack } from "@mui/material";

const TestEventCard = (props) => {
  const { data, role = "admin" } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileDetailsRedux = useSelector(
    (state) => state.profileDetails.profileDetails
  );
  const [isEditModalClose, setEditModalClose] = useState(true);
  const [successModal, setSuccessModal] = useState(true);
  const [apiSuccess, setApiSuccess] = useState(false);
  useEffect(() => {
    if (apiSuccess) {
      dispatch(eventListTrigger());
    }
    console.log(decryptUrl(data.bannerimage));
  }, [apiSuccess]);
  return (
    <div
      className={`${classes.card}`}
      onClick={
        data.archive && data.cancelComment
          ? () => { }
          : () => {
            localStorage.eventOrganizerName =
              data?.createdByFirstName + " " + data.createdByLastName;
            navigate(`/home/events/event-detail/${data.id}`);
          }
      }
      style={{
        cursor: data.archive && data.cancelComment ? "default" : "pointer",
      }}
    >
      {/* <img alt="" src={data.bannerimage ? baseToImg(data.bannerimage) : ""} /> */}
      <div
        className={classes["banner-container"]}
        style={{ position: "relative", overflow: "hidden" }}
      >
        <img
          alt=""
          src={
            data.bannerimage
              ? addParamsURL(decryptUrl(data.bannerimage), { size: "s" })
              : ""
          }
        />
        <CardOverlay style={{ borderRadius: "24px" }} />
      </div>
      <span>
        <img
          alt=""
          // src={data.eventTypeIcon ? baseToImg(data.eventTypeIcon) : ""}
          src={data.eventTypeIcon ? decryptUrl(data.eventTypeIcon) : ""}
        />

        {data.eventTypeName}
      </span>
      {data?.isAutoApproval && (
        <div className={classes["public-label"]}>
          <BadgeV2 label="Public" informationKind="label" size="xtra-large" />
        </div>
      )}
      <Stack direction="column" justifyContent="space-between" flex={1}>
        <div className={classes.details}>
          <h6>{data.name}</h6>
          <div>
            <img alt="" src={icCalendarRound} />
            <p>
              {data.startDate} {data.startDate !== data.endDate && `(From)`}
            </p>
          </div>

          {data.startDate === data.endDate ? (
            <div>
              <img alt="" src={icClockRound} />
              <p>{data.time}</p>
            </div>
          ) : (
            <div>
              <img alt="" src={icCalendarRound} />
              <p>{data.endDate} (To)</p>
            </div>
          )}
          {role == "admin" && (
            <div>
              <img alt="" src={icTeamRound} />

              <p>
                {data.attendeeCount}{" "}
                {profileDetailsRedux?.userType === "SCHOOL"
                  ? `Student${data.attendeeCount > 1 ? "s" : ""}`
                  : `Guest${data.attendeeCount > 1 ? "s" : ""}`}
              </p>
            </div>
          )}
          {role == "photographer" && (
            <div>
              <div
                style={{
                  borderRadius: "20px",
                  padding: "3px",
                  backgroundColor: "var(--color-sparkle-grey-20)",
                }}
              >
                <Icon ic="IcUser" color="grey-60" size="medium" />
              </div>
              <p>
                {data.createdByFirstName + " " + data.createdByLastName}{" "}
                (Organizer)
              </p>
            </div>
          )}

          <div>
            <img alt="" src={icLocationRound} />
            <Tooltip label={data.locationName} position="bottom">
              <p>{data.locationName}</p>
            </Tooltip>
          </div>

          {/* Reschedule form Modal */}
          <JdsModal
            header="Reschedule Event"
            size="m"
            close={isEditModalClose}
            onClose={() => {
              setEditModalClose(true);
            }}
          >
            {!isEditModalClose && (
              <RescheduleEventForm
                eventDetails={data}
                setSuccessModal={() => {
                  setSuccessModal(false);
                }}
              />
            )}
          </JdsModal>
          {!successModal && (
            <SuccessModal
              close={successModal}
              onClose={() => {
                setSuccessModal(true);
                setApiSuccess(true);
              }}
              subtitle="Your event has been rescheduled successfully."
              btnAction={() => {
                setSuccessModal(true);
                // setApiSuccess(true);
                navigate(`/home/events/event-detail/${data?.id}`);
              }}
              btnText="Go to Event"
            />
          )}
        </div>

        <Container
          fullWidth
          horizontalAlign="space-between"
          verticalAlign="center"
          style={{ paddingInline: "16px", marginBlock: "16px" }}
        >
          {data.archive && data.cancelComment && (
            <BadgeV2
              label={`Event Cancelled : ${data.cancelComment}`}
              color="negative"
              informationKind="label"
              size="small"
            />
          )}

          {/* // <Button
            //   kind="primary"
            //   label="more info"
            //   onClick={() => navigate(`/home/events/event-detail/${data.id}`)}
            // /> */}

          {data.archive && (
            <Icon
              ic={"IcCalendarWeek"}
              onClick={() => setEditModalClose(false)}
            />
          )}
        </Container>
      </Stack>
    </div>
  );
};

export default TestEventCard;
